export default __webpack_public_path__ + "static/media/Search.1ff193be.svg";